import { SideListOrganizationOrders } from '@widgets/side-list-organization-orders/ui/side-list-organization-orders';
import React, { useState } from 'react';
import { Wrapper } from './side-view-manager.styles';
import { AccordionOrganizationShortInfo } from '@entities/organization/ui/accordion-organization-short-info/accordion-organization-short-info';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { useCurrentOrganizationPreviewSharedQuery } from '@entities/organization/libs/hooks/use-current-organization-preview-shared-query/use-current-organization-preview-shared-query';
import { ModalOrderDetailedInfo } from '@widgets/modal-order-detailed-info/modal-order-detailed-info';

export const SideViewManager: React.FC = () => {
    const user = useCurrentUserSelector();
    const [, getCurrentOrganizationPreviewResult] = useCurrentOrganizationPreviewSharedQuery(user?.company?.id || 0);
    const currentOrganizationData = getCurrentOrganizationPreviewResult.data;
    const [orderCardId, setOrderCardId] = useState<number>();

    const handleClickOrderCardId = (id: number) => {
        setOrderCardId(id);
    };

    return (
        <Wrapper>
            <AccordionOrganizationShortInfo
                isInitialized={Boolean(currentOrganizationData)}
                organization={currentOrganizationData}
                isLoading={
                    getCurrentOrganizationPreviewResult.isFetching ||
                    getCurrentOrganizationPreviewResult.isLoading ||
                    getCurrentOrganizationPreviewResult.isUninitialized
                }
                errorMessage={getQueryError(getCurrentOrganizationPreviewResult)?.message}
            />
            <SideListOrganizationOrders onClickOrderCard={handleClickOrderCardId} />
            <ModalOrderDetailedInfo
                isShow={Boolean(orderCardId)}
                orderId={orderCardId}
                onClose={() => setOrderCardId(undefined)}
            />
        </Wrapper>
    );
};
